import m from "./design-system.es280.js";
import { openBlock as n, createElementBlock as o, normalizeClass as u, createElementVNode as d, createTextVNode as s, toDisplayString as h, renderSlot as c, createCommentVNode as f } from "vue";
/* empty css                    */
import g from "./design-system.es128.js";
const p = 300, y = {
  name: "DsTextAreaField",
  props: {
    /**
     * Label to render above the input field when active
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Placeholder text for when the input is empty
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * HTML input element name
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Control hiding the input
     */
    hidden: Boolean,
    /**
     * Prevent user from typing in the input
     */
    readonly: Boolean,
    /**
     * Required field for validation purposes
     */
    required: Boolean,
    /**
     * Controls visualization of rendering form validation error states
     */
    submitted: Boolean,
    /**
     * Forces invalid form field
     */
    invalid: Boolean,
    /**
     * Control trimming the text value from the input on change to vmodel
     */
    trim: Boolean,
    /**
     * Input value
     */
    modelValue: String,
    /**
     * Auto focus on this input containing component renders
     */
    autofocus: Boolean,
    /**
     * Control whether you allow users to have the ability to autofill/autocomplete this input from things like Google
     */
    autocomplete: {
      type: [Boolean, String],
      default: !1
    },
    /**
     * String list of classes to apply to the input element
     */
    inputClassList: {
      type: String,
      default: ""
    },
    /**
     * Automatically resize the height to fit the text inside
     */
    autoGrow: Boolean,
    /**
     * Maximum length of the text area field
     */
    maxlength: {
      type: Number,
      default: 2e3
    },
    /**
     * Display textarea value in monospace.
     */
    monospace: Boolean
  },
  emits: [
    "blur",
    "selected",
    "update:modelValue"
  ],
  data() {
    return {
      value: this.modelValue
    };
  },
  computed: {
    autocompleteValue() {
      const { autocomplete: e } = this;
      return e === !0 ? "on" : e === !1 ? "off" : e;
    },
    isDirty() {
      return !!this.value;
    }
  },
  watch: {
    modelValue(e) {
      this.updateValue(e);
    },
    invalid() {
      this.checkInvalid();
    }
  },
  created() {
    this.adjustHeight = m(this.adjustHeight, p), this.updateValue(this.modelValue);
  },
  mounted() {
    this.checkInvalid(), this.adjustHeight();
  },
  methods: {
    adjustHeight() {
      this.autoGrow && this.$nextTick(() => {
        const { input: e } = this.$refs;
        e && (e.style.height = "auto", e.style.height = `${e.scrollHeight + 8}px`);
      });
    },
    handleInput(e) {
      this.adjustHeight(), this.updateValue(e.target.value), this.$emit("update:modelValue", this.value);
    },
    updateValue(e) {
      this.value = this.trim && e ? e.trim() : e;
    },
    checkInvalid() {
      this.$refs.input && (this.invalid ? this.$refs.input.setCustomValidity("invalid") : this.$refs.input.setCustomValidity(""));
    },
    handleSelect({ target: e } = { target: { selectionStart: null, selectionEnd: null } }) {
      const { selectionStart: l, selectionEnd: t } = e;
      this.$emit("selected", { selectionStart: l, selectionEnd: t });
    },
    // Legacy method to focus the input, not used internally but consumers may be using it via ref
    input_focus() {
      this.$refs.input.focus();
    }
  }
}, v = ["id", "value", "name", "placeholder", "required", "readonly", "autofocus", "maxlength", "autocomplete"], V = ["for"], B = {
  key: 0,
  class: "assistive-text"
};
function S(e, l, t, b, r, a) {
  return n(), o("div", {
    class: u(["input-field", { "no-label": !t.label }])
  }, [
    d("textarea", {
      id: t.name,
      ref: "input",
      value: r.value,
      name: t.name,
      class: u([{
        dirty: a.isDirty,
        hidden: t.hidden,
        submitted: t.submitted,
        monospace: t.monospace,
        "auto-grow": t.autoGrow
      }, t.inputClassList]),
      placeholder: t.placeholder,
      required: t.required,
      readonly: t.readonly,
      autofocus: t.autofocus,
      maxlength: t.maxlength,
      autocomplete: a.autocompleteValue,
      onInput: l[0] || (l[0] = (...i) => a.handleInput && a.handleInput(...i)),
      onBlur: l[1] || (l[1] = (i) => e.$emit("blur", i)),
      onSelect: l[2] || (l[2] = (...i) => a.handleSelect && a.handleSelect(...i))
    }, null, 42, v),
    l[3] || (l[3] = s()),
    d("label", { for: t.name }, h(t.label), 9, V),
    l[4] || (l[4] = s()),
    e.$slots.help ? (n(), o("div", B, [
      c(e.$slots, "help", {}, void 0, !0)
    ])) : f("", !0)
  ], 2);
}
const k = /* @__PURE__ */ g(y, [["render", S], ["__scopeId", "data-v-a0c836e7"]]);
export {
  k as default
};
//# sourceMappingURL=design-system.es107.js.map
